/* eslint-disable camelcase */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table, Input, Row, Col } from "antd";
import moment from "moment";

import { getGatewaySuspiciousLogs } from "../../../redux/actions/Gateway";

import generateQuery, { handleSearch as search } from "../../../util/table";
import PageLimitSwitch from "../../../components/PageLimitSwitch";

const columns = [
  {
    title: "Created",
    dataIndex: "created_at",
    render: (date) => <span>{moment(date).format("DD/MM/YY h:mm:ss a")}</span>,
    sorter: true,
    search: false,
  },
  {
    title: "Account Number",
    dataIndex: "accountNumber",
    sorter: true,
  },
  {
    title: "Amount",
    dataIndex: "amount",
    sorter: true,
    type: "number",
  },
  {
    title: "attempts",
    dataIndex: "attempts",
    sorter: true,
  },
  {
    title: "Currency",
    dataIndex: "currency",
    sorter: true,
  },
  {
    title: "Gateway reference",
    dataIndex: "gatewayReference",
    sorter: true,
    width: 200,
  },
  {
    title: "Ip address",
    dataIndex: "ip",
    sorter: true,
    width: 200,
  },
  {
    title: "Gateway Reference",
    dataIndex: "kitegatewayReference",
    sorter: true,
  },
  {
    title: "Processor Code",
    dataIndex: "serviceType",
    sorter: true,
  },
  {
    title: "Processor name",
    dataIndex: "processorName",
    sorter: true,
    width: 150,
  },
  {
    title: "Processor Reference",
    dataIndex: "processorReference",
    sorter: true,
  },
  {
    title: "Request type",
    dataIndex: "request_type",
    sorter: true,
  },
  {
    title: "Request Method",
    dataIndex: "request_method",
    sorter: true,
  },
  {
    title: "Unknown reference",
    dataIndex: "unknown_reference",
    sorter: true,
  },
  {
    title: "Url",
    dataIndex: "url",
    sorter: true,
  },
];

const Callbacks = () => {
  const dispatch = useDispatch();
  const { data, pageSize, currentPage, totalRecords, loading } = useSelector(
    ({ gateway }) => gateway.gateway_suspicious_logs
  );
  const [searchParams, setSearchParams] = useState("");

  useEffect(() => {
    const pagination = `page=${currentPage}&limit=${pageSize}`;
    dispatch(getGatewaySuspiciousLogs(pagination));
  }, [dispatch, pageSize, currentPage]);

  const dataSource = data?.map(
    ({
      _id,
      attempts,
      amount,
      account_number: accountNumber,
      ip,
      kitegateway_reference: kitegatewayReference,
      service_type: serviceType,
      processor_name: processorName,
      processor_reference: processorReference,
      request_type: requestType,
      unknown_reference: unknownReference,
      currency,
      url,
      created_at,
      updated_at,
    }) => ({
      key: _id,
      attempts,
      amount,
      accountNumber,
      ip,
      kitegatewayReference,
      serviceType,
      processorName,
      processorReference,
      requestType,
      unknownReference,
      currency,
      url,
      created_at,
      updated_at,
    })
  );

  const handleOnChange = (pagination, filters, sorter) => {
    dispatch(
      getGatewaySuspiciousLogs(
        generateQuery(pagination, filters, sorter, searchParams)
      )
    );
  };

  const handleSearch = (searchValue) => {
    const query = search(
      searchValue,
      dispatch,
      getGatewaySuspiciousLogs,
      columns
    );
    setSearchParams(query);
  };

  const props = {
    pagination: false,
    onChange: handleOnChange,
    loading,
    columns,
    dataSource,
  };

  return (
    <div>
      <h2 className="title gx-mb-4">Suspicious Logs</h2>
      <div className="gx-d-flex justify-content-center">
        <Input.Search
          placeholder="Search Suspicious Logs"
          enterButton
          allowClear
          onSearch={handleSearch}
        />
      </div>
      <div className="gx-d-flex justify-content-center">
        <Table className="gx-table-responsive striped-table" {...props} />
      </div>
      <Row className="pagination">
        <Col md={12}>
          <PageLimitSwitch
            resourceType="gateway_suspicious_logs"
            limit={pageSize}
            limits={[10, 100, 200, 500, 1000, 2000, 5000, 10000]}
            totalRecords={totalRecords}
            currentPage={currentPage}
          />
        </Col>
      </Row>
    </div>
  );
};

export default Callbacks;
